import { CurrencyDisplayUtil } from './../../common/currency-display-util';
import { AmChartsService } from '@amcharts/amcharts3-angular';
import { SurvivalHorizonService } from './../../survival-horizon/survival-horizon.service';
import { DashboardEventService } from './../../dashboard/dashboard-event.service';
import { MetricSelection } from './../metric-selection';
import { Component, OnInit, Input, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ProjectionMetric } from './projection-metric';
import { TrendMetric } from './../trend-metric/trend-metric';

@Component({
    selector: 'app-projection-metric',
    templateUrl: './projection-metric.component.html',
    styleUrls: ['./projection-metric.component.scss', './../trend-metric/trend-metric.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectionMetricComponent implements OnInit, OnDestroy {
    @Input()
    projectionMetric: ProjectionMetric;

    constructor(private amCharts: AmChartsService,
        private survivalHorizonService: SurvivalHorizonService,
        private dashboardEventService: DashboardEventService,
        private changeDetectorRef: ChangeDetectorRef) {

    }

    ngOnInit() {
    }

    ngOnDestroy() {
        this.changeDetectorRef.detach();
    }

    refreshMetric() {
        this.changeDetectorRef.markForCheck();
    }

    onHistory() {
        // this.dashboardEventService.metricSelectionSubject.next(
        //     new MetricSelection(this.projectionMetric.currency, this.projectionMetric.metricType, this.projectionMetric.name)
        // );
    }
    lightMetricColor(projectionMetric: ProjectionMetric) {
        if (projectionMetric.initialized) {
            if (projectionMetric.unexpectedAmount < 0) {
                return TrendMetric.C_900[2];
            } else {
                return TrendMetric.C_900[4];
            }
        }
    }

    formatNet(value: number): string {
        return CurrencyDisplayUtil.toShortNumber(value, 2);
    }
}
